// src/pages/HomePage.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext.js";
import { useLanguage } from "../context/LanguageContext.js";
import { t } from "../utils/translations.js";
import { Container, Row, Col, Button } from "react-bootstrap";

import "./HomePage.css";

export default function HomePage() {
  const { user } = useAuth();
  const { language } = useLanguage();
  const navigate = useNavigate();

  const nameToShow = user?.displayName || user?.email || "Colaborador";
  const slug = encodeURIComponent(nameToShow);
  const firstName = nameToShow.split(" ")[0];

  return (
    <Container fluid className="home-page-container">
      {/* Header Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            {t(language, "homeWelcome")},
            <span className="hero-name">{firstName}!</span>
          </h1>
          <p className="hero-subtitle">
            {t(language, "homeManageReports")}
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="home-content">
        {user?.isAdmin ? (
          /* Admin Dashboard */
          <Row className="g-4 mb-4">
            <Col lg={6}>
              <div className="feature-card admin-card" onClick={() => navigate("/admin/users")}>
                <div className="card-icon">👥</div>
                <h3>{t(language, "homeEmployeeReports")}</h3>
                <p>{t(language, "homeViewManageReports")}</p>
                <div className="card-footer">
                  <Button className="card-button">
                    {t(language, "homeAccessReports")} →
                  </Button>
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <div className="feature-card admin-card secondary" onClick={() => navigate("/admin/clients")}>
                <div className="card-icon">🏢</div>
                <h3>{t(language, "homeManageClients")}</h3>
                <p>{t(language, "homeManageClientsDesc")}</p>
                <div className="card-footer">
                  <Button className="card-button">
                    {t(language, "homeManageClients")} →
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        ) : (
          /* User Dashboard */
          <Row className="g-4 mb-4">
            <Col lg={4}>
              <div
                className="feature-card user-card primary"
                onClick={() => navigate(`/colaborador/${slug}`)}
              >
                <div className="card-icon">📋</div>
                <h3>{t(language, "homeWeeklyReport")}</h3>
                <p>{t(language, "homeCreateReport")}</p>
                <div className="card-footer">
                  <Button className="card-button">
                    {t(language, "homeSubmitReport")} →
                  </Button>
                </div>
              </div>
            </Col>

            <Col lg={4}>
              <div
                className="feature-card user-card secondary"
                onClick={() => navigate(`/reports/${slug}`)}
              >
                <div className="card-icon">📊</div>
                <h3>{t(language, "homeViewReports")}</h3>
                <p>{t(language, "homeViewReportsDesc")}</p>
                <div className="card-footer">
                  <Button className="card-button">
                    {t(language, "homeViewReports")} →
                  </Button>
                </div>
              </div>
            </Col>

            <Col lg={4}>
              <div
                className="feature-card user-card"
                onClick={() => navigate("/tutorial")}
              >
                <div className="card-icon">📖</div>
                <h3>{t(language, "homeAppTutorial")}</h3>
                <p>{t(language, "homeLearnApp")}</p>
                <div className="card-footer">
                  <Button className="card-button">
                    {t(language, "homeViewTutorial")} →
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {/* Additional Section */}
        <Row className="g-4">
          <Col lg={12}>
            <div className="info-section">
              <div className="info-card">
                <span className="info-icon">💡</span>
                <div className="info-text">
                  <h5>{t(language, "homeNeedHelp")}</h5>
                  <p>{t(language, "homeHealthSafetyDocs")}</p>
                </div>
                <Button
                  variant="outline-primary"
                  onClick={() => navigate("/health-safety")}
                  className="info-button"
                >
                  {t(language, "homeLearnMore")}
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
}
